<ng-container *transloco="let t">
  <mat-icon [matTooltip]="t.offline">signal_wifi_off</mat-icon>
</ng-container>
